<template>
    <div>
        <ModalCommon :id="`ModalSelectCampaignCopy`" :config="config" @save="handleSave()" @close="handleClose()">
            <div class="col-sm-12">
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.nameCampaign') }} </label>
                    <div class="col-sm-8">
                        <Multiselect
                            :id="`select-campaign-for-landing-page`"
                            :value.sync="formView.campaign"
                            :options="listDataMasterCampaign"
                            :config.sync="configFieldSelectCampaign"
                            @select="onHandleChoiceCP"
                        />
                    </div>
                </div>
            </div>
        </ModalCommon>
    </div>
</template>

<script>
import ModalCommon from '@/components/Modal/main.vue';
import Multiselect from '@/components/Multiselect/main.vue';

import { mapState } from 'vuex';
import { landingPageMethods } from '@/state/helpers';
import { cloneDeep } from 'lodash';
import { handleMapDataFromStateLP } from '../../../handlers';

export default {
    name: 'ModalSelectCampaignCopy',
    components: {
        ModalCommon,
        Multiselect
    },
    props: {
        config: {
            type: Object
        },
        dataView: {
            type: Object,
            require: true
        },
        masterCampaign: {
            type: Array
        }
    },
    data() {
        return {
            configFieldSelectCampaign: {
                trackBy: 'id',
                label: 'name',
                errorField: this.$t('pageReturnPrize.nameCampaign'),
                valueSync: null,
                loading: false,
                error: false,
                isRemove: true,
                isRequired: false,
                typesValidate: []
            },
            listDataMasterCampaign: this.masterCampaign,
            formView: cloneDeep(this.dataView)
        };
    },
    computed: {
        ...mapState({
            ...mapState('landingPage', ['allInforCampaignLP'])
        })
    },
    methods: {
        ...landingPageMethods,

        handleSave() {
            this.$emit('copy', this.formView);
        },

        handleClose() {},

        async onHandleChoiceCP() {
            await this.getDetailCampaignForLandingPage(this.formView.campaign.id);
            handleMapDataFromStateLP(this.formView, this.allInforCampaignLP);
        }
    },
    watch: {
        masterCampaign: {
            handler: function (newMasterCampaign) {
                this.listDataMasterCampaign = newMasterCampaign;
            },
            immediate: true,
            deep: true
        },

        'config.model': {
            handler: function (newModel) {
                if (newModel) {
                    this.formView = cloneDeep(this.dataView);
                }
            },
            immediate: true
        }
    }
};
</script>

<style lang="scss" scoped></style>
